import './MyAccount.css';
import { useListOrderForUserQuery, useUpdateOrderForUserMutation } from '../../api/order.api';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingComponent from "../../common/Loading/Loading.component";
import Swal from 'sweetalert2'
import { auth } from '../../../firebase';
import { signOut } from 'firebase/auth';
import { logoutUser } from '../../reducer/user.reducer';
import { onAuthStateChanged } from "firebase/auth";
import { useState } from 'react';

const MyAccount = () => {
    const loggedInUser = useSelector((state) => state.user.loggedInUser);

    const [isAdmin, setIsAdmin] = useState(false);
    const [isStaff, setIsStaff] = useState(false);
       
    const { data, error, isLoading, refetch } = useListOrderForUserQuery({ page: 1, limit: 10, search: '' });
    const [cancleOrder] = useUpdateOrderForUserMutation()
    const navigate = useNavigate();
    const dispatch = useDispatch()
    

    const deleteData = async(rowId)=>{        
            try{
                const result = await Swal.fire({
                    title: "Are you sure want to cancle your order?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, cancel it!",
                    cancelButtonText: "No, let it be",
                  })
                  if(result.isConfirmed){
                    await cancleOrder(rowId).unwrap()
                    toast.success("Order canceled sucessfully")
                    refetch();
                }
    
            }catch(exception){
                toast.error("Error canceling order")
            }
    }
    const logout = async () => {
        try {
            toast.loading("Logging out...");            
            await signOut(auth);
            
            localStorage.removeItem('_at');
            localStorage.removeItem('_rt');

            dispatch(logoutUser());
    
            toast.dismiss();
            toast.success("You have been logged out successfully")
            
            setTimeout(() => {
                navigate('/login');
            }, 1000);
        } catch (error) {
            console.error("Logout failed:", error);
            toast.error("Logout failed");
        }
    };

    onAuthStateChanged  (auth, async(user) => {
        if (user) {
            const token = await user.getIdTokenResult();            // User is signed in
            if (token.claims.role === "admin") {
                setIsAdmin(true);
            } else if(token.claims.role === "staff") {
                setIsStaff(true);
            } else {
                setIsAdmin(false);
                setIsStaff(false);
            }
        }
    }); 

    if (isLoading) {
        return <LoadingComponent
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            backgroundColor: '#f9f9f9',
          }} 
         />;
      }
    const orders = data?.result;
    const hasOrders = orders && orders.length > 0;
    return (
        <div className="my_account">
            {/* Profile Section */}
            <div className="profile_header">
                <div className="profile_info_group">
                    <div className="avatar_circle">
                        {loggedInUser?.name ? loggedInUser.name.charAt(0).toUpperCase() : 'U'}
                    </div>
                    <div className="user_details">
                        <h1>{loggedInUser?.name || 'Valued Member'}</h1>
                        <p>{loggedInUser?.email}</p>
                    </div>
                </div>
                <button className="logout_btn" onClick={logout}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    Log Out
                </button>
                {
                    isAdmin && (
                        <button className="logout_btn" onClick={() => navigate('/dashboard')}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16 17 21 12 16 7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                            Admin Dashboard
                        </button>
                    )
                }
                {
                    isStaff && (
                        <button className="logout_btn" onClick={() => navigate('/dashboard/order_list')}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                <polyline points="16 17 21 12 16 7"></polyline>
                                <line x1="21" y1="12" x2="9" y2="12"></line>
                            </svg>
                            Dashboard
                        </button>
                    )
                }
            </div>

            {/* Order History Section */}
            <div className="section_header">
                <h2>Order History</h2>
            </div>

            {hasOrders ? (
                <div className="order_list">
                    {orders.map((order) => (
                        <div key={order._id} className="order_card">
                            <div className="order_card_header">
                                <div className="order_meta">
                                    <h3>Order ID</h3>
                                    <p>#{order.orderId}</p>
                                </div>
                                <div className={`status_badge status_${order.orderStatus.toLowerCase()}`}>
                                    {order.orderStatus}
                                </div>
                            </div>

                            <div className="order_items_list">
                                {order.items.map((item, idx) => (
                                    <div key={`${order._id}-${idx}`} className="order_item_row">
                                        <img src={item.productImage} alt={item.title} className="item_thumb" />
                                        <div className="item_info">
                                            <h4>{item.title}</h4>
                                            <p>Size: {item.size} | Qty: {item.quantity}</p>
                                            <p style={{fontWeight: '500'}}>Rs. {item.price?.toLocaleString()}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="order_card_footer">
                                <div className="grand_total_box">
                                    <p>Grand Total</p>
                                    <h4>Rs. {order.total?.toLocaleString()}</h4>
                                </div>
                                {order.orderStatus.toLowerCase() === 'pending' && (
                                    <span 
                                        className="cancel_order_link" 
                                        onClick={() => deleteData(order._id)}
                                    >
                                        Cancel Order
                                    </span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="empty_account_state">
                    <h2>No orders yet</h2>
                    <p>Looks like you haven't made your first purchase yet.</p>
                    <Link to="/all_product" className="shop_now_btn" style={{marginTop: '20px'}}>
                        Start Shopping
                    </Link>
                </div>
            )}
        </div>
    );
};

export default MyAccount;
